export const getAndroidApi = () => {
    if (!('AnalyticsWebInterface' in window)) {
        return undefined;
    }
    return window.AnalyticsWebInterface;
};
export const getAndroidEventLogger = () => {
    const androidApi = getAndroidApi();
    if (!androidApi) {
        return undefined;
    }
    return (event) => {
        if (typeof androidApi.logTrackingEvent === 'function') {
            androidApi.logTrackingEvent(event.name, JSON.stringify(event.params), JSON.stringify({
                isPrivacyFriendly: event.isPrivacyFriendly,
            }));
        }
        else if (typeof androidApi.logGa4Event === 'function') {
            androidApi.logGa4Event(event.name, JSON.stringify(event.params));
        }
    };
};
//# sourceMappingURL=android.js.map